import { type ImageModel, type ImageResolution } from '@backend/lib/ai/functions/generateImage'

export type { ImageResolution }

const MODEL_RESOLUTIONS: Partial<Record<ImageModel, ImageResolution[]>> = {
  flux: ['1K', '2K'],
  'flux-2-pro': ['1K', '2K'],
  'flux-2-max': ['1K', '2K'],
  'flux-2-flex': ['1K', '2K'],
  'flux-2-klein': ['1K', '2K'],
  'flux-3-klein': ['1K', '2K', '4K'],
  gemini: ['1K'],
  'gemini-2.5-flash-image': ['1K'],
  'gemini-3.1-flash-image-preview': ['1K', '2K', '4K'],
  'gemini-3-pro-image-preview': ['1K', '2K', '4K'],
  'gemini-nano-banana-2.1': ['1K'],
}

export function getAvailableResolutions(model?: ImageModel): ImageResolution[] {
  if (!model) return ['1K']
  return MODEL_RESOLUTIONS[model] ?? ['1K']
}

export interface GenerateImageOptions {
  referenceImages?: string[]
  steps?: number
  guidance?: number
  useCaption?: boolean
  useColorPalette?: boolean
  resolution?: ImageResolution
  enhance?: boolean
}
